import { Injectable } from '@angular/core';

@Injectable()
export class OrderByService {

  instant(array: any[], field: string, desc: boolean): any[] {
    if (!field) {
      return array;
    }
    const fields = field.split('.');

    array.sort((a: any, b: any) => {
      const aValue = this.getValue(a, fields);
      const bValue = this.getValue(b, fields);
      if (aValue < bValue) {
        return -1;
      } else if (aValue > bValue) {
        return 1;
      } else {
        return 0;
      }
    });
    if ( desc ) {
      return array.reverse();
    }
    return array;
  }

  private getValue(obj, fields) {
    let value = obj;
    fields.forEach(field => value = value ? value[field] : null);
    return value;
  }
}
